import React, { useState, useEffect } from 'react';
import { UAParser } from 'ua-parser-js';
import { Row, Col } from 'antd';
import { decode } from 'js-base64'
import { postHttpClient } from '../../helpers'

import './VroomSurvey.css';

let HOME_URL = ''
let logo_url = '/portal/img/logo.svg'
if (window.location.hostname === 'localhost' || window.location.hostname === 'meet-dev.truevirtualworld.com') {
  HOME_URL = 'https://vroom-ts2.truevirtualworld.com'
  logo_url = 'https://vroom-ts2.truevirtualworld.com/portal/img/logo.svg'
}

const RATING_OPTIONS = [
    { value: 1, label: 'Poor' },
    { value: 2, label: 'Fair' },
    { value: 3, label: 'Good' },
    { value: 4, label: 'Great' },
    { value: 5, label: 'Excellent' },
];

const getReadableUserAgent = () => {
    const parser = new UAParser();
    const result = parser.getResult();
    return {
        browser: `${result.browser.name || 'Unknown'} ${result.browser.version || ''}`.trim(),
        os: `${result.os.name || 'Unknown'} ${result.os.version || ''}`.trim(),
        device: result.device.type || 'desktop', 
        device_model: result.device.model || 'Unknown',
        raw_ua: result.ua 
    };
};

const getUnifiedClientInfo = (networkInfo) => {
    const uaInfo = getReadableUserAgent(); 
    return {
        id: localStorage.getItem("clientId"),
        platform: "web", 
        os: uaInfo.os, 
        device_model: uaInfo.device_model || 'desktop',
        browser: uaInfo.browser, 
        network_type: networkInfo.connection_type || 'unknown',
        carrier: null 
    };
};

const getNetworkInfo = () => {
    const networkInfo = {
        connection_type: 'Unknown',
        downlink: 'Unknown',
        rtt: 'Unknown',
        ip: 'Unknown'
    };

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
        networkInfo.connection_type = connection.effectiveType; 
        networkInfo.downlink = connection.downlink; 
        networkInfo.rtt = connection.rtt; 
    }
    return networkInfo;
};

const createSurvey = async (body, lkToken, vToken) => {
    const url = `${window._env_.SupportCenterUrl}/v1/api/survey/create`
    try {
        let headers = {
            Authorization: "Bearer " + lkToken,
            'Content-Type': 'application/json'
        }
        if (vToken && vToken != null) {
            headers.vtoken = vToken
        }
        const result = await postHttpClient(undefined, url, headers, body)
        return result
    } catch (error) {
        console.log('create survey error')
    }
}

const queryString = window.location.search;

const VroomSurvey = ({ open=true, onSubmitSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    //const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const vToken = localStorage.getItem("vtoken")
    const lkToken = params.get('token');
    const paramData = params.get('data');

    window.history.replaceState(null, null, window.location.pathname)
    
    let data = {};
    if (paramData !== null && paramData !== '') {
        console.debug('VroomSurvey', { paramData })
        const dataDecode = decodeURI(decode(paramData))
        data = JSON.parse(dataDecode)
    }

    if (!lkToken || lkToken==='') {
        window.location.href = `${HOME_URL}/portal`;
    }

    const networkInfo = getNetworkInfo();
    const clientInfo = getUnifiedClientInfo(networkInfo);
    data.client = { ...clientInfo, ...data.client }
    console.debug('VroomSurvey', { data })
    const [selectedRating, setSelectedRating] = useState(null);
    const [comment, setComment] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false); 

    useEffect(() => {
        if (open) {
            setSelectedRating(null);
            setComment('');
            setIsSubmitted(false);
        }
    }, [open]);

    if (!open) return null;

    const handleSubmit = async() => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        data.rate = selectedRating || 0
        data.additional_comments = comment
        createSurvey(data, lkToken, vToken).then(() => {
            setIsSubmitted(true);
            setTimeout(() => {
                window.location.href = `${HOME_URL}/portal`;
            }, 2500);
        })
    };

    const handleCancel = (reason = '') => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        data.rate = 0
        data.additional_comments = reason
        createSurvey(data, lkToken, vToken).then(() => {
            window.location.href = `${HOME_URL}/portal`
        })
    };

    return (
        <div className="vroom-survey-overlay">
            <div className="vroom-survey-modal">
                
                {isSubmitted ? (
                    <div className="vroom-survey-thankyou-container">
                        <div className="vroom-survey-success-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        <h2 className="vroom-survey-thankyou-title">Thank you!</h2>
                        <p className="vroom-survey-thankyou-desc">Your feedback helps us improve VROOM</p>
                    </div>
                ) : (
                    <>
                        <Row justify="space-between" align="middle" className="vroom-survey-header">
                            <Col>
                                <div className="vroom-survey-logo">
                                    <img style={{ height: '48px' }} src={logo_url} alt='logo' />
                                </div>
                            </Col>
                            <Col>
                                <button className="vroom-survey-close-btn" onClick={()=>handleCancel('X')}>✕</button>
                            </Col>
                        </Row>

                        <Row className="vroom-survey-sec1">
                            <Col span={24} className="vroom-survey-titles">
                                <h2>How was your meeting experience?</h2>
                                <p>Your feedback helps us improve your experience</p>
                            </Col>
                        </Row>

                        {/* ปรับปรุง Section 2: ให้แนบเลข 1-5 ไปกับ class selected ด้วย */}
                        <div className="vroom-survey-rating-row">
                            {RATING_OPTIONS.map((option) => (
                                <div 
                                    key={option.value}
                                    className="vroom-survey-rating-item"
                                    onClick={() => setSelectedRating(option.value)}
                                >
                                    <div className={`vroom-survey-circle ${selectedRating === option.value ? `selected-${option.value}` : ''}`}>
                                        {option.value}
                                    </div>
                                    <div className={`vroom-survey-circle-label ${selectedRating === option.value ? `selected-${option.value}` : ''}`}>
                                        {option.label}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {selectedRating && (
                            <Row className="vroom-survey-sec3">
                                <Col span={24}>
                                    <textarea
                                        className="vroom-survey-textarea"
                                        placeholder="Any additional comments (optional)"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                    ></textarea>
                                </Col>
                            </Row>
                        )}

                        <Row justify="space-between" align="middle" className="vroom-survey-actions">
                            <Col span={12} style={{ textAlign: 'center' }}>
                                <button className="vroom-survey-btn-skip" onClick={()=>handleCancel('Skip')} disabled={isSubmitting}>Skip</button>
                            </Col>
                            <Col span={12}>
                                <button 
                                    className={`vroom-survey-btn-submit ${selectedRating ? 'survey-active' : 'survey-disabled'}`} 
                                    onClick={handleSubmit}
                                    disabled={!selectedRating || isSubmitting}
                                >
                                    Submit Feedback
                                </button>
                            </Col>
                        </Row>
                    </>
                )}

            </div>
        </div>
    );
}

export default VroomSurvey;